import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './guards/auth.guard';
import { ConfirmaInvitacionComponent } from './confirma-invitacion/confirma-invitacion.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      // {
      //   path: 'dashboard',
      //   loadChildren: './starter/starter.module#StarterModule'
      // },
      {
        path: 'configurations',
        loadChildren: './v2/configuraciones/configuraciones.module#ConfiguracionesModule'
      },
      {
        path: 'espaces',
        loadChildren: './v2/espaces/espaces.module#EspacesModule'
      },
      {
        path: 'eventos',
        loadChildren: './v2/events/events.module#EventosModule'
      },
      {
        path: 'stats',
        loadChildren: './stats/stats.module#StatsModule'
      },
      {
        path: 'masters',
        loadChildren: './v2/masters/masters.module#MastersModule'
      },
      {
        path: 'promotions',
        loadChildren: './v2/promotions/promotions.module#PromotionsModule'
      },
      {
        path: 'tarjetas',
        loadChildren: './v2/tarjetas/tarjetas.module#TarjetasModule'
      },
      {
        path: 'invitaciones',
        loadChildren: './invitaciones/invitaciones.module#InvitacionesModule'
      },
      {
        path: 'digitalmenu',
        loadChildren: './v2/digitalmenu/digitalmenu.module#DigitalMenuModule'
      },
      {
        path: 'controlrequest',
        loadChildren: './v2/controlrequest/controlrequest.module#ControlRequestModule'
      },
      {
        path: 'profile',
        loadChildren: './profile/profile.module#ProfileModule'
      },
      {
        path: 'users',
        loadChildren: './v2/users/users.module#UsuariosModule'
      },
      //{
      //  path: 'routes',
      //  loadChildren: './rutas/rutas.module#RutasModule'
      //},
      {
        path: 'destination',
        loadChildren: './v2/destination/destination.module#DestinationModule'
      },
      {
        path: 'helpcenter',
        loadChildren: './v2/helpCenter/helpcenter.module#HelpCenterModule'
      },
      {
        path: 'campaigns',
        loadChildren: './campaign/campaign.module#CampaignModule'
      },
      {
        path: 'saldos',
        loadChildren: './v2/saldos/saldos.module#SaldosModule'
      }
    ]
  },
  {
    path: 'login',
    loadChildren: './v2/entry/entry.module#EntryModule',
  },
  {
    path: 'customers',
    canActivate: [AuthGuard],
    loadChildren: './v2/customers/customers.module#CustomersModule'
  },
  {
    path: 'confirmacion-evento/:id',
    component: ConfirmaInvitacionComponent,
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule { }


